export default __webpack_public_path__ + "static/media/DSC_8094.a29759c5.jpg";